export function getTokenListViewLink(source: string): string {
  return `https://tokenlists.org/token-list?url=${source}`
}
